module.exports = __webpack_public_path__ + "static/lembagagetah-7bcbf8b9a2ae25b389464863f1674436.png";